import React from "react"
import axios from "axios"
import Urls from "../Urls";
import LocalToken from "../Method/LocalToken";

const RefreshTokenReq = () => {
    let url = Urls.RefreshToken()
    return axios({
        method: "Get",
        url,
        headers: {
            'Authorization': `Bearer ${LocalToken.Get() && LocalToken.Get().refToken ? LocalToken.Get().refToken : null}`,
        },
    });
}
export default RefreshTokenReq;